import { StepInitAnalyzeUrl } from '@backstage/plugin-catalog-import';
import Typography from '@mui/material/Typography';

const EXAMPLE_LOCATION_URL =
  'https://gitlab.collaborationlayer-traton.com/project-group/project/-/blob/main/catalog-info.yaml';

type Props = { analysisUrl: string; onAnalysis: () => void };

export const CustomAnalyzeStepContent = ({
  analysisUrl,
  onAnalysis,
}: Props) => {
  return (
    <>
      <Typography variant="body1" paragraph>
        Enter the URL of the software's{' '}
        <pre style={{ display: 'inline', margin: 0 }}>
          <strong>catalog-info.yaml</strong>
        </pre>{' '}
        file. This file contains metadata about the software and is used to
        register it as a component in the Traton Developer Portal Catalog.
      </Typography>
      <StepInitAnalyzeUrl
        key="analyze"
        analysisUrl={analysisUrl}
        onAnalysis={onAnalysis}
        disablePullRequest
        exampleLocationUrl={EXAMPLE_LOCATION_URL}
      />
    </>
  );
};

export default CustomAnalyzeStepContent;
